import {Ways} from "../components/Ways";
import {gsap} from "gsap";
import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";

export class FITH2ReelForeground extends PIXI.Container implements StageLayer {
    private _ways: Ways;
    constructor() {
        super();
        this.name = "ReelFrame";
        this.init();
    }

    private init() {
        this.position.set(360, 360);
        this._ways = new Ways();
        this.addChild(this._ways);
        this.onResize();
    }

    public onResize(): void {
        const isLandscape: boolean = NolimitApplication.isLandscape;
        this._ways.position.x = isLandscape ? -449 : -289;
        this._ways.position.y = isLandscape ? -294 : -350;
    }

    public reset(): void {
        this._ways.reset();
    }

    public updateWays(totalWays: number): gsap.core.Timeline {
        return this._ways.updateValue(totalWays);
    }

    public show(): void {
        this._ways.visible = true;
        gsap.to(this._ways, 0.3, {alpha:1});
    }

    public hide(): gsap.core.Timeline {
        return gsap.timeline().add(gsap.to(this._ways, 0.3, {alpha:0})).add(()=>{this._ways.visible = false;});
    }

    public onAnticipationFail(): void {
        return;
    }

    public get ways():Ways {
        return this._ways;
    }
}